import { render, staticRenderFns } from "./SliderElementSettings.vue?vue&type=template&id=42b3b8b9&scoped=true&"
import script from "./SliderElementSettings.vue?vue&type=script&lang=ts&"
export * from "./SliderElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b3b8b9",
  null
  
)

export default component.exports